// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddOrderLineData, AddOrderLineErrors, AddOrderLineResponses, AssignProductToDeviceData, AssignProductToDeviceErrors, AssignProductToDeviceResponses, CreateOrderData, CreateOrderErrors, CreateOrderResponses, DeleteOrderData, DeleteOrderErrors, DeleteOrderLineData, DeleteOrderLineErrors, DeleteOrderLineResponses, DeleteOrderResponses, GetDeviceAssignmentsData, GetDeviceAssignmentsErrors, GetDeviceAssignmentsResponses, GetOrderData, GetOrderErrors, GetOrderResponses, GetOrdersData, GetOrdersErrors, GetOrdersResponses, GetProductsData, GetProductsErrors, GetProductsForAnAccountData, GetProductsForAnAccountErrors, GetProductsForAnAccountResponses, GetProductsResponses, UnassignProductFromDeviceData, UnassignProductFromDeviceErrors, UnassignProductFromDeviceResponses, UpdateOrderData, UpdateOrderErrors, UpdateOrderLineData, UpdateOrderLineErrors, UpdateOrderLineResponses, UpdateOrderResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Add a new order line to a specific order.
 */
export const addOrderLine = <ThrowOnError extends boolean = false>(options: Options<AddOrderLineData, ThrowOnError>): RequestResult<AddOrderLineResponses, AddOrderLineErrors, ThrowOnError> => (options.client ?? client).post<AddOrderLineResponses, AddOrderLineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orderlines/{orderId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an existing order line for a specific order.
 */
export const deleteOrderLine = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderLineData, ThrowOnError>): RequestResult<DeleteOrderLineResponses, DeleteOrderLineErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrderLineResponses, DeleteOrderLineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orderlines/{orderId}/{orderLineId}',
    ...options
});

/**
 * Update an existing order line for a specific order.
 */
export const updateOrderLine = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderLineData, ThrowOnError>): RequestResult<UpdateOrderLineResponses, UpdateOrderLineErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrderLineResponses, UpdateOrderLineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orderlines/{orderId}/{orderLineId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all orders for a specific account.
 */
export const getOrders = <ThrowOnError extends boolean = false>(options: Options<GetOrdersData, ThrowOnError>): RequestResult<GetOrdersResponses, GetOrdersErrors, ThrowOnError> => (options.client ?? client).get<GetOrdersResponses, GetOrdersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{accountId}',
    ...options
});

/**
 * Create a new order for a specific account.
 */
export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>): RequestResult<CreateOrderResponses, CreateOrderErrors, ThrowOnError> => (options.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{accountId}',
    ...options
});

/**
 * Delete an existing order for a specific account.
 */
export const deleteOrder = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderData, ThrowOnError>): RequestResult<DeleteOrderResponses, DeleteOrderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrderResponses, DeleteOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{accountId}/{orderId}',
    ...options
});

/**
 * Get a specific order for a specific account.
 */
export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>): RequestResult<GetOrderResponses, GetOrderErrors, ThrowOnError> => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{accountId}/{orderId}',
    ...options
});

/**
 * Update an existing order for a specific account.
 */
export const updateOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderData, ThrowOnError>): RequestResult<UpdateOrderResponses, UpdateOrderErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrderResponses, UpdateOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{accountId}/{orderId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign a product to a specific device.
 */
export const assignProductToDevice = <ThrowOnError extends boolean = false>(options: Options<AssignProductToDeviceData, ThrowOnError>): RequestResult<AssignProductToDeviceResponses, AssignProductToDeviceErrors, ThrowOnError> => (options.client ?? client).post<AssignProductToDeviceResponses, AssignProductToDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/device/assignment/account/{accountId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign a product from a specific device.
 */
export const unassignProductFromDevice = <ThrowOnError extends boolean = false>(options: Options<UnassignProductFromDeviceData, ThrowOnError>): RequestResult<UnassignProductFromDeviceResponses, UnassignProductFromDeviceErrors, ThrowOnError> => (options.client ?? client).delete<UnassignProductFromDeviceResponses, UnassignProductFromDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/device/assignment/{deviceId}/{productId}',
    ...options
});

/**
 * Get all product assignments for a specific device.
 */
export const getDeviceAssignments = <ThrowOnError extends boolean = false>(options: Options<GetDeviceAssignmentsData, ThrowOnError>): RequestResult<GetDeviceAssignmentsResponses, GetDeviceAssignmentsErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceAssignmentsResponses, GetDeviceAssignmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/device/assignment/{deviceId}',
    ...options
});

/**
 * Get all products.
 */
export const getProducts = <ThrowOnError extends boolean = false>(options?: Options<GetProductsData, ThrowOnError>): RequestResult<GetProductsResponses, GetProductsErrors, ThrowOnError> => (options?.client ?? client).get<GetProductsResponses, GetProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/products',
    ...options
});

/**
 * Get all products for a specific account.
 */
export const getProductsForAnAccount = <ThrowOnError extends boolean = false>(options: Options<GetProductsForAnAccountData, ThrowOnError>): RequestResult<GetProductsForAnAccountResponses, GetProductsForAnAccountErrors, ThrowOnError> => (options.client ?? client).get<GetProductsForAnAccountResponses, GetProductsForAnAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/products/{accountId}',
    ...options
});
